import axios from 'axios';

// axios.defaults.headers.common['Content-Type'] = 'application/json';
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
// axios.defaults.headers.common['authKey'] = sessionStorage.getItem('authKey'); //relevant only for candidates, admins and users does not have authKey, they are validated either by windows authentication or by FIM

const axiosUploadInstance = axios.create({
    baseURL: window.location.hostname == 'localhost' ? 'http://apps/ReliabilityCheck/' : process.env.PUBLIC_URL //'http://appqa.mod.int/RCWin/'//window.location.hostname
});

//configure pipeline
axiosUploadInstance.interceptors.request.use(request =>{
    // request.headers.authKey = sessionStorage.getItem('authKey');
    return request
}, error =>{
    console.log(error);
    return Promise.reject(error);
});

axiosUploadInstance.interceptors.response.use(response => {
    return response;
});

export default axiosUploadInstance;